<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                element="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.tags', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.group')" for="active" />
                        <FormSelect
                            id="group_id"
                            v-model="form.group_id"
                            :options="options.groups"
                            :null-option="true"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.group_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <EmptyState v-if="students.length === 0" picture />
        <div class="flex flex-col mt-5" v-else>
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.group') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.students', 1) }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.illness') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $tc('messages.comment', 2) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="studentIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(student, studentIndex) in students"
                                :key="student.id"
                            >
                                <td class="px-1 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ student.group_name }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    <StudentInfoItem :student="student" />
                                </td>
                                <td class="px-1 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ student.illnesses }}
                                </td>
                                <td class="px-1 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ student.health_comment }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import StudentInfoItem from '@/components/StudentInfoItem.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    components: {
        EmptyState,
        SubmitFormButton,
        FormLabel,
        FormSelect,
        FormError,
        StudentInfoItem,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'students', 'options', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                group_id: this.filters.group_id,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
